
const BASE_URL = 'https://stage-apiv2.myearth.id'; // Replace with your backend base URL
//const BASE_URL = 'http://localhost:3030'; // Replace with your backend base URL


export const getNotificationsByUserId = async (user_id) => {
  try {
    console.log(`📩 Fetching notifications for user: ${user_id}`);
    const res = await fetch(`${BASE_URL}/notifications/user/${user_id}`);
    const data = await res.json();

    if (!res.ok) throw new Error(data.message || 'Failed to fetch notifications');
    console.log('✅ Notifications fetched:', data);
    return data;
  } catch (err) {
    console.error('❌ Error fetching notifications:', err);
    return [];
  }
};

export const clearNotificationById = async (id) => {
  try {
    console.log(`🗑️ Deleting notification: ${id}`);
    const res = await fetch(`${BASE_URL}/notifications/clear/${id}`, {
      method: 'DELETE'
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || 'Failed to delete notification');
    console.log('✅ Notification deleted:', data);
    return data;
  } catch (err) {
    console.error('❌ Error deleting notification:', err);
    return null;
  }
};

export const clearAllNotificationsByUser = async (userId) => {
  try {
    console.log(`🧹 Clearing all notifications for user: ${userId}`);
    const res = await fetch(`${BASE_URL}/notifications/clear-all/${userId}`, {
      method: 'DELETE'
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || 'Failed to clear all notifications');
    console.log('✅ All notifications cleared:', data);
    return data;
  } catch (err) {
    console.error('❌ Error clearing notifications:', err);
    return null;
  }
};
